<template>
  <div class="confirmation-contents">
    <div id="loader-wrap">
      <div class="load-block">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
      </div>
    </div>
    <div id="confirmation-screen">
      <h1 class="top-title">
        <picture>
          <source srcset="@/assets/img/pc/ttl_contact.svg" media="(min-width: 681px)" />
          <source srcset="@/assets/img/sp/ttl_contact.svg" media="(max-width: 680px)" />
          <img src="@/assets/img/pc/ttl_contact.svg" alt="お問い合わせ" class="img">
        </picture>
      </h1>
      <p class="text">以下の内容で送信してよろしいですか？</p>
        <div class="input-contents">
          <div class="block">
            <label class="item-name">お名前<span class="required">必 須</span></label>
            <div class="in">
              <span class="last-name">{{ fname }}</span><span>{{ lname }}</span>
            </div>
          </div>
          <div class="block">
            <label class="item-name">会社名<span class="required">必 須</span></label>
            <p class="in">{{ companyName }}</p>
          </div>
          <div class="block">
            <label class="item-name">会社URL</label>
            <p class="in">{{ companyUrl }}</p>
          </div>
          <div class="block">
            <label class="item-name">メールアドレス<span class="required">必 須</span></label>
            <p class="in">{{ mailAddress }}</p>
          </div>
          <div class="block">
            <label class="item-name">電話番号<span class="required">必 須</span></label>
            <p class="in">{{ tel }}</p>
          </div>
          <div class="block">
            <label class="item-name">ご予算</label>
            <p class="in">{{ budget }}</p>
          </div>
          <div div class="block">
            <label class="item-name">広告するサイトURL</label>
            <p class="in">{{ advertiseSite }}</p>
          </div>
          <div div class="block">
            <label class="item-name">広告開始希望時期</label>
            <p class="in">{{ start }}</p>
          </div>
          <div div class="block">
            <label class="item-name">お問い合わせ内容</label>
            <p class="in">{{getInquiry}}</p>
          </div>
          <div div class="block">
            <label class="item-name">お問い合わせ内容詳細</label>
            <p class="in">{{ subject }}</p>
          </div>
        </div>
        <div id="btn" class="btn" @click="click" ontouchstart=””>
          <picture>
            <source srcset="@/assets/img/pc/btn_send.svg" media="(min-width: 681px)" />
            <source srcset="@/assets/img/sp/btn_send.svg" media="(max-width: 680px)" />
            <img src="@/assets/img/pc/btn_send.svg" alt="" class="img">
          </picture>
        </div>
    </div>
  </div>
</template>

<script>

const axios = require('axios').default;

export default {
  data() {
    return {
      fname: "",
      lname: "",
      companyName: "",
      companyUrl: "",
      mailAddress: "",
      tel: "",
      budget: "",
      advertiseSite: "",
      start: "",
      inquiry: [],
    }
  },
  created() {
    this.fname = this.$route.params.fname
    this.lname = this.$route.params.lname
    this.companyName = this.$route.params.companyName
    this.companyUrl = this.$route.params.companyUrl
    this.mailAddress = this.$route.params.mailAddress
    this.tel = this.$route.params.tel
    this.budget = this.$route.params.budget
    this.advertiseSite = this.$route.params.advertiseSite
    this.start = this.$route.params.start
    this.inquiry = this.$route.params.inquiry
    this.subject = this.$route.params.subject
  },
  mounted() {
    window.scrollTo({
      top: 0,
    })
  },
  methods: {
    click: function(){

      // ローディング表示
      let loading = document.getElementById('loader-wrap');
      loading.style.display = 'flex';

      let btn = document.getElementById('btn');
      btn.style.pointerEvents = 'none';
      axios.post(process.env.VUE_APP_CONTACT_FORM_API_URL, {
      fname: this.fname,
      lname: this.lname,
      companyName: this.companyName,
      companyUrl: this.companyUrl,
      mailAddress: this.mailAddress,
      tel: this.tel,
      budget: this.budget,
      advertiseSite: this.advertiseSite,
      start: this.start,
      inquiry: this.getInquiry,
      subject: this.subject,
    })
    .then(() => {
      // ローディング終了
      loading.style.display = 'none';

      this.$router.push({
      path: '/send'
      })
    })
    .catch(function () {
      // ローディング終了
      loading.style.display = 'none';

      let btn = document.getElementById('btn');
      btn.style.pointerEvents = 'auto';
      window.alert("通信に失敗しました、時間をおいてお試しください。");
    });
    }
  },

  computed: {
    getInquiry() {
      let string = "";
      for (let i = 0; i < this.inquiry.length; i++) {
        string += this.inquiry[i]+', ';
      }

      return string;
    }
  }
}
</script>